import { CandidateServiceProvider } from './CandidateServiceProvider'

export {
    useCandidateService,
    useRejectCandidateBulk,
    useSendCandidateMessageBulkAction,
    useSendCandidateNoteBulkAction,
    useGetChangeStatus,
} from './candidateServiceHooks'

export default CandidateServiceProvider
